import React from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import './SupportModals.css';

const ConfirmationModal = ({ isOpen, onClose, onConfirm, title, message }) => {
  const { t } = useTranslation();
  
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="admin-modal-overlay" onClick={onClose}>
      <div className="admin-modal-content confirmation-modal" onClick={(e) => e.stopPropagation()}>
        <div className="admin-modal-header">
          <h3>{title}</h3>
          <button onClick={onClose} className="close-btn">×</button>
        </div>
        <div className="admin-modal-form">
          <p>{message}</p>
          <div className="confirmation-buttons">
            {/* DÜZELTME: Varsayılan değerler kaldırıldı */}
            <button onClick={onClose} className="btn-secondary">{t('cancel')}</button>
            <button onClick={onConfirm} className="btn-danger">{t('confirm')}</button>
          </div>
        </div>
      </div>
    </div>,
    document.getElementById('modal-root')
  );
};

export default ConfirmationModal;